export const MODAL_TYPES = {
  LOGIN: "LOGIN",
  FEEDBACK: "FEEDBACK",
  // TRANSPORTSUPPORT: "TRANSPORTSUPPORT",
};
